import React, { useCallback, useEffect, useState } from 'react'
import { isEmpty } from 'lodash-es'
import { TtIconButton } from '@23/react'
import { intl } from 'lang/intl'
import { TooltipComponent } from '../../../sharedLegacy/components'
import { WebinarPanelComponent } from '../../../sharedLegacy/features/WebinarSidebarFeature/components'
import { useWebinarColors } from '../../../sharedLegacy/hooks/useWebinarColors'
import {
  useOverlayState,
  changeOverlay,
  removeOverlay,
} from '../../../firebase/hooks/useOverlays'

import './OverlayCornerTagInputComponent.scss'

const OverlayCornerTagInputComponent = () => {
  const overlay = useOverlayState()

  const isShowingCornerTagOverlay = overlay?.type === 'cornertag'
  const overlayText = isShowingCornerTagOverlay ? overlay.text : ''
  const [text, setText] = useState(overlayText)

  useEffect(() => {
    /*
     * In case Fireabse and local state are different then we update text to show what is in Firebase
     * this may trigger in case there is corner tag shown and the producer just joins the room, for example after reconnect/page refresh
     */
    if (isShowingCornerTagOverlay) {
      setText(overlayText)
    }
  }, [overlayText, isShowingCornerTagOverlay])

  const isDisabled = isEmpty(text)
  const { tabs, accent } = useWebinarColors()

  const styles = {
    '--up-next-input-text-color': tabs.contrast,
    '--up-next-input-placeholder-color': tabs.contrast.transparent('50%'),
    '--up-next-button-color': tabs.contrast.transparent('87%'),
    '--up-next-button-color-disabled': tabs.contrast.transparent('20%'),
  }

  const handleClick = useCallback(() => {
    if (isDisabled) {
      return
    }

    if (isShowingCornerTagOverlay) {
      removeOverlay()
      setText('')
    } else {
      changeOverlay({
        type: 'cornertag',
        data: { text },
      })
    }
  }, [isDisabled, isShowingCornerTagOverlay, text])

  const getTooltip = () => {
    if (isDisabled) {
      return intl.formatMessage({ defaultMessage: 'Start typing to activate' })
    }

    if (isShowingCornerTagOverlay) {
      return intl.formatMessage({ defaultMessage: 'Remove from the video' })
    }

    return intl.formatMessage({ defaultMessage: 'Display on the video' })
  }

  const getAriaLabel = () => {
    if (isDisabled) {
      return intl.formatMessage({
        defaultMessage: 'Start typing to activate the show info banner ',
      })
    }

    if (isShowingCornerTagOverlay) {
      return intl.formatMessage({
        defaultMessage: 'Remove info banner from the video',
      })
    }

    return intl.formatMessage({
      defaultMessage: 'Display info banner on the video',
    })
  }

  return (
    <div className="overlay-corner-tag-input-component">
      <WebinarPanelComponent isWithoutPadding>
        <div className="input-enclosure" style={styles}>
          <input
            type="text"
            placeholder={intl.formatMessage({
              defaultMessage: "What's coming up next?",
            })}
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={isShowingCornerTagOverlay}
            aria-label="Info banner text input"
          />
          <TooltipComponent title={getTooltip()} placement="topRight">
            <TtIconButton
              style={{
                '--hover-color': accent.color,
                color: isShowingCornerTagOverlay ? accent.color : 'inherit',
              }}
              name="eye"
              disabled={isDisabled}
              onClick={handleClick}
              label={getAriaLabel()}
            />
          </TooltipComponent>
        </div>
      </WebinarPanelComponent>
    </div>
  )
}

export default OverlayCornerTagInputComponent
